// extracted by mini-css-extract-plugin
export default {"orderHistory":"jd-z","header":"kd-z"};